import { Box, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';

import { Demand } from '../models/demand';

/**
 * Members who reported a need of those invited, in the demand list and in the
 * cockpit (GF 30.10.2026, #2340). Nothing is counted before the invitation
 * went out.
 */
export const PaloResponseCountCell = ({ count }: { count: Demand['responseCount'] }): ReactElement =>
    count ? (
        <Tooltip
            placement="top"
            title={
                <FormattedMessage
                    id="app.demands.responseCount.tooltip"
                    values={{ reported: count.reported, declined: count.declined, open: count.open }}
                />
            }
        >
            <Box component="span">
                {count.reported}/{count.invited}
            </Box>
        </Tooltip>
    ) : (
        <>–</>
    );
